import * as THREE from "three";
import { ExtraType } from "../entities/LedExtras";
export class Dimensions {
    constructor(left, right, far, close, rotated) {
        if (rotated === true) {
            this.right = close;
            this.far = right;
            this.left = far;
            this.close = left;
            this.centerPos = new THREE.Vector3(left.position.x, 0, far.position.z);
        }
        else {
            this.right = right;
            this.left = left;
            this.far = far;
            this.close = close;
            this.centerPos = new THREE.Vector3(left.position.x, 0, close.position.z);
        }
    }
}
export class GetDimensions {
    constructor(data, scene) {
        this.scene = scene;
        this.calculate(data);
    }
    calculate(data) {
        const rotated = data.measuredModel.rotated;
        const modulesX = data.measuredModel.modulesX;
        const modulesZ = data.measuredModel.modulesZ;
        let w = rotated ? data.projectionValue : data.widthValue;
        let p = rotated ? data.widthValue : data.projectionValue;
        const width = data.measuredModel.width;
        const projection = data.measuredModel.projection;
        let projectProjection = p - (modulesX - 1) * (data.measuredModel.model.edgeWidth);
        let projectWidth = w - (modulesZ - 1) * (data.measuredModel.model.edgeWidth);
        let leftPos;
        let rightPos;
        let closeSidePos;
        let farSidePos;
        let zWidth;
        let xWidth;
        let leftDiv;
        let rightDiv;
        let closeDiv;
        let farDiv;
        // Calculate the frames. A frame is the space between legs
        if (data.measuredModel.model.id < 4) {
            leftDiv = 1;
            rightDiv = 1;
            closeDiv = 1;
            farDiv = 1;
            // Check if the extras requires more legs to span. Then calculate the frames according to that
            if (rotated === false) {
                // LEFT
                if (projection > 400 && this.scene.getActualSide("LEFT").extra === ExtraType.PARAPET || projection > 400 && this.scene.getActualSide("LEFT").extra === ExtraType.PARAPET_ZIPSCREEN)
                    leftDiv = 2;
                else if (projection > 500 && this.scene.getActualSide("LEFT").extra === ExtraType.ZIPSCREEN || projection > 500 && this.scene.getActualSide("LEFT").extra === ExtraType.GLASS_ZIPSCREEN)
                    leftDiv = 2;
                // RIGHT
                if (projection > 400 && this.scene.getActualSide("RIGHT").extra === ExtraType.PARAPET || projection > 400 && this.scene.getActualSide("RIGHT").extra === ExtraType.PARAPET_ZIPSCREEN)
                    rightDiv = 2;
                else if (projection > 500 && this.scene.getActualSide("RIGHT").extra === ExtraType.ZIPSCREEN || projection > 500 && this.scene.getActualSide("RIGHT").extra === ExtraType.GLASS_ZIPSCREEN)
                    rightDiv = 2;
                // CLOSE
                if (width > 400 && this.scene.getActualSide("CLOSE").extra === ExtraType.PARAPET || width > 400 && this.scene.getActualSide("CLOSE").extra === ExtraType.PARAPET_ZIPSCREEN)
                    closeDiv = 2;
                else if (width > 500 && this.scene.getActualSide("CLOSE").extra === ExtraType.ZIPSCREEN || width > 500 && this.scene.getActualSide("CLOSE").extra === ExtraType.GLASS_ZIPSCREEN)
                    closeDiv = 2;
                // FAR
                if (width > 400 && this.scene.getActualSide("FAR").extra === ExtraType.PARAPET || width > 400 && this.scene.getActualSide("FAR").extra === ExtraType.PARAPET_ZIPSCREEN)
                    farDiv = 2;
                else if (width > 500 && this.scene.getActualSide("FAR").extra === ExtraType.ZIPSCREEN || width > 500 && this.scene.getActualSide("FAR").extra === ExtraType.GLASS_ZIPSCREEN)
                    farDiv = 2;
            }
            // Rotated
            else {
                if (width > 400 && this.scene.getActualSide("LEFT").extra === ExtraType.PARAPET || width > 400 && this.scene.getActualSide("LEFT").extra === ExtraType.PARAPET_ZIPSCREEN)
                    farDiv = 2;
                else if (width > 500 && this.scene.getActualSide("LEFT").extra === ExtraType.ZIPSCREEN || width > 500 && this.scene.getActualSide("LEFT").extra === ExtraType.GLASS_ZIPSCREEN)
                    farDiv = 2;
                if (width > 400 && this.scene.getActualSide("RIGHT").extra === ExtraType.PARAPET || width > 400 && this.scene.getActualSide("RIGHT").extra === ExtraType.PARAPET_ZIPSCREEN)
                    closeDiv = 2;
                else if (width > 500 && this.scene.getActualSide("RIGHT").extra === ExtraType.ZIPSCREEN || width > 500 && this.scene.getActualSide("RIGHT").extra === ExtraType.GLASS_ZIPSCREEN)
                    closeDiv = 2;
                if (projection > 400 && this.scene.getActualSide("CLOSE").extra === ExtraType.PARAPET || projection > 400 && this.scene.getActualSide("CLOSE").extra === ExtraType.PARAPET_ZIPSCREEN)
                    leftDiv = 2;
                else if (projection > 500 && this.scene.getActualSide("CLOSE").extra === ExtraType.ZIPSCREEN || projection > 500 && this.scene.getActualSide("CLOSE").extra === ExtraType.GLASS_ZIPSCREEN)
                    leftDiv = 2;
                // FAR
                if (projection > 400 && this.scene.getActualSide("FAR").extra === ExtraType.PARAPET || projection > 400 && this.scene.getActualSide("FAR").extra === ExtraType.PARAPET_ZIPSCREEN)
                    rightDiv = 2;
                else if (projection > 500 && this.scene.getActualSide("FAR").extra === ExtraType.ZIPSCREEN || projection > 500 && this.scene.getActualSide("FAR").extra === ExtraType.GLASS_ZIPSCREEN)
                    rightDiv = 2;
            }
            if (projection > 600 && !rotated) {
                leftDiv = 2;
                rightDiv = 2;
            }
            if (width > 600 && rotated) {
                closeDiv = 2;
                farDiv = 2;
            }
        }
        else {
            if (width <= 450) {
                closeDiv = 1;
                farDiv = 1;
            }
            else if (width <= 900) {
                closeDiv = 2;
                farDiv = 2;
            }
            else {
                closeDiv = 3;
                farDiv = 3;
            }
            if (projection > 700) {
                leftDiv = 2;
                rightDiv = 2;
            }
            else {
                leftDiv = 1;
                rightDiv = 1;
            }
            if (projection > 400 && projection < 800 && this.scene.getActualSide("LEFT").extra === ExtraType.PARAPET || projection > 400 && projection < 800 && this.scene.getActualSide("LEFT").extra === ExtraType.PARAPET_ZIPSCREEN)
                leftDiv = 2;
            // RIGHT
            if (projection > 400 && projection <= 800 && this.scene.getActualSide("RIGHT").extra === ExtraType.PARAPET || projection > 400 && projection < 800 && this.scene.getActualSide("RIGHT").extra === ExtraType.PARAPET_ZIPSCREEN)
                rightDiv = 2;
            if (projection > 800 && projection <= 1000 && this.scene.getActualSide("LEFT").extra === ExtraType.PARAPET || projection > 800 && projection < 1000 && this.scene.getActualSide("LEFT").extra === ExtraType.PARAPET_ZIPSCREEN)
                leftDiv = 4;
            // RIGHT
            if (projection > 800 && projection < 1000 && this.scene.getActualSide("RIGHT").extra === ExtraType.PARAPET || projection > 800 && projection < 1000 && this.scene.getActualSide("RIGHT").extra === ExtraType.PARAPET_ZIPSCREEN)
                rightDiv = 4;
            // CLOSE
            if (width > 800 && width < 901 && this.scene.getActualSide("CLOSE").extra === ExtraType.PARAPET || width > 400 && width < 901 && this.scene.getActualSide("CLOSE").extra === ExtraType.PARAPET_ZIPSCREEN)
                closeDiv = 4;
            // FAR
            if (width > 800 && width < 901 && this.scene.getActualSide("FAR").extra === ExtraType.PARAPET || width > 400 && width < 901 && this.scene.getActualSide("FAR").extra === ExtraType.PARAPET_ZIPSCREEN)
                farDiv = 4;
        }
        leftPos = new THREE.Vector3(projectProjection / 2 - projection / 2 + ((modulesX - 1) * data.measuredModel.model.edgeWidth / 2), 260 / 2, projectWidth - width / 2 - data.measuredModel.model.edgeWidth / 2);
        rightPos = new THREE.Vector3(projectProjection / 2 - projection / 2 + ((modulesX - 1) * data.measuredModel.model.edgeWidth / 2), 260 / 2, -width / 2 + data.measuredModel.model.edgeWidth / 2);
        closeSidePos = new THREE.Vector3(p - projection / 2, 260 / 2, projectWidth / 2 - width / 2);
        farSidePos = new THREE.Vector3(-projection / 2, 260 / 2, projectWidth / 2 - width / 2);
        zWidth = projectProjection + data.measuredModel.model.edgeWidth + data.measuredModel.model.edgeWidth * (data.measuredModel.modulesX - 1);
        xWidth = projectWidth;
        this.dimensions = new Dimensions(
        //Purple - GREEN
        new ModelSide(leftPos, 0, data.measuredModel.modulesX, zWidth, leftDiv), 
        //White -- YELLOW
        new ModelSide(rightPos, 0, data.measuredModel.modulesX, zWidth, rightDiv), 
        // Yellow -- PURPLE
        new ModelSide(farSidePos, 90, data.measuredModel.modulesZ, xWidth, farDiv), 
        // Green - PURPLE
        new ModelSide(closeSidePos, 90, data.measuredModel.modulesZ, xWidth, closeDiv), data.measuredModel.rotated);
        /*        // Only for debug purposes
                const geom = new THREE.BoxGeometry(data.measuredModel.model.edgeWidth, data.measuredModel.model.edgeHeight, data.measuredModel.model.edgeWidth)
                const mesh = new THREE.Mesh(geom, new THREE.MeshBasicMaterial({color: 0xFFFFFF}))
                const mesh1 = new THREE.Mesh(geom, new THREE.MeshBasicMaterial({color: 0x696DEA}))
                const mesh2 = new THREE.Mesh(geom, new THREE.MeshBasicMaterial({color: 0x69EAE0}))
                const mesh3 = new THREE.Mesh(geom, new THREE.MeshBasicMaterial({color: 0xE5D409}))
                mesh.position.copy(this.dimensions.right.position)
                mesh.rotateY(degToRad(90))
                mesh1.position.copy(this.dimensions.left.position)
                mesh1.rotateY(degToRad(90))
                mesh2.position.copy(this.dimensions.close.position)
                mesh3.position.copy(this.dimensions.far.position)
                this.scene.threeScene.add(mesh, mesh1, mesh2, mesh3)*/
    }
}
export class ModelSide {
    constructor(pos, rotation, modules, length, divided) {
        this.length = length;
        this.modules = modules;
        this.position = pos;
        this.rotationY = rotation;
        this.divided = divided;
        this.createFrames();
    }
    createFrames() {
        this.frames = this.length / (this.length / (this.modules * this.divided));
    }
}
